<app-route-point-details-status-term
  type="arrival"
  [point]="point()"
  [isCanceled]="isCanceled()"
></app-route-point-details-status-term>

<app-route-point-details-status-in-progress
  [point]="point()"
  [isCanceled]="isCanceled()"
></app-route-point-details-status-in-progress>

<app-route-point-details-status-term
  type="departure"
  [point]="point()"
  [isCanceled]="isCanceled()"
></app-route-point-details-status-term>

@if (['map', 'swapPanel'].includes(context)) {
  <onyx-divider></onyx-divider>
}
